document.addEventListener("DOMContentLoaded", function() {
    const rechargeWidget = document.querySelector('.recharge-recurring-options');

    if (rechargeWidget) {
        // Customize Widget Titles
        let titles = rechargeWidget.querySelectorAll('.rc-radio__label');
        titles.forEach(title => {
            if (title.textContent.includes('Subscribe & Save')) {
                title.textContent = "Subscribe & Save 15% (Best Value!)"; // Customize this label text
            }
        });

        // Customize Frequency Label
        let frequencyLabels = rechargeWidget.querySelectorAll('.rc_frequency');
        frequencyLabels.forEach(label => {
            label.textContent = label.textContent.replace('Every', 'Deliver every'); // Change label from 'Every' to 'Deliver every'
        });
    }
});